<div class="header-container mt-45">
  <h3>User Management</h3>
  <button
    matButton="elevated"
    class="charcoal-button"
    [disabled]="repairSiteStatus === 'PENDING'"
    (click)="addEditUser.emit()">
    ADD NEW USER
  </button>
</div>
<mat-divider />

<div class="user-management-section">
  <table
    (matSortChange)="onSortEvent($event)"
    [dataSource]="usersDataSource"
    class="table-style mt-10"
    mat-table
    matSort
    matSortActive="permission"
    matSortDirection="asc"
    matSortDisableClear>
    <ng-container matColumnDef="permission">
      <th *matHeaderCellDef [class.active]="activeColumn === 'permission'" mat-header-cell mat-sort-header>
        Permissions
      </th>
      <td *matCellDef="let user" mat-cell>
        <div class="primary-contact">
          {{ user.privileges.length > 0 ? 'Administrator' : 'Repairer' }}
          @if (user.isPrimaryContact) {
            <mat-icon [matTooltipPosition]="'above'" matTooltip="Primary contact" tooltipClass="body-2">
              phone_callback
            </mat-icon>
          }
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="username">
      <th *matHeaderCellDef [class.active]="activeColumn === 'username'" mat-header-cell mat-sort-header>Username</th>
      <td *matCellDef="let user" mat-cell>{{ user.username }}</td>
    </ng-container>
    <ng-container matColumnDef="firstName">
      <th *matHeaderCellDef [class.active]="activeColumn === 'firstName'" mat-header-cell mat-sort-header>
        First Name
      </th>
      <td *matCellDef="let user" mat-cell>{{ user.firstName }}</td>
    </ng-container>
    <ng-container matColumnDef="lastName">
      <th *matHeaderCellDef [class.active]="activeColumn === 'lastName'" mat-header-cell mat-sort-header>Last Name</th>
      <td *matCellDef="let user" mat-cell>{{ user.lastName }}</td>
    </ng-container>
    <ng-container matColumnDef="phone">
      <th *matHeaderCellDef [class.active]="activeColumn === 'phone'" mat-header-cell mat-sort-header>Phone</th>
      <td *matCellDef="let user" mat-cell>{{ user.phone }}</td>
    </ng-container>
    <ng-container matColumnDef="email">
      <th *matHeaderCellDef [class.active]="activeColumn === 'email'" mat-header-cell mat-sort-header>Email</th>
      <td *matCellDef="let user" mat-cell>{{ user.email }}</td>
    </ng-container>
    <ng-container matColumnDef="isActivated">
      <th *matHeaderCellDef [class.active]="activeColumn === 'isActivated'" mat-header-cell mat-sort-header>Status</th>
      <td *matCellDef="let user" mat-cell>
        <span
          [appHighlightStatus]="user.isActivated ? (user.status === 'ENABLED' ? 'ACTIVE' : user.status) : 'INVITED'">
          {{ user.isActivated ? (user.status === 'ENABLED' ? 'Active' : (user.status | titlecase)) : 'Invited' }}
        </span>
      </td>
    </ng-container>
    <ng-container matColumnDef="kebab">
      <th *matHeaderCellDef mat-header-cell></th>
      <td *matCellDef="let user" mat-cell>
        @if (currentUser?.privileges?.includes('REPADMIN') || currentUser?.privileges?.includes('SYSADMIN')) {
          <div class="secondary-icon">
            <button matIconButton [matMenuTriggerFor]="userMenu" (click)="$event.stopPropagation()">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #userMenu="matMenu" class="kebab-menu">
              @if (!user.isActivated) {
                <button mat-menu-item (click)="confirmDeleteInvitedUser.emit(user.username)">
                  <span>Delete</span>
                </button>
              }
              @if (user.isActivated && (user.status === 'ENABLED' || user.status === 'SUSPENDED')) {
                <button mat-menu-item (click)="enableDisableUser.emit({ user: user, disable: true })">
                  <span>Disable User</span>
                </button>
              }
              @if (user.isActivated && (user.status === 'DISABLED' || user.status === 'SUSPENDED')) {
                <button mat-menu-item (click)="enableDisableUser.emit({ user: user, disable: false })">
                  <span>Enable User</span>
                </button>
              }
            </mat-menu>
          </div>
        }
      </td>
    </ng-container>

    <tr *matHeaderRowDef="usersColumnHeaders" mat-header-row></tr>
    <tr *matRowDef="let row; columns: usersColumnHeaders" mat-row (click)="addEditUser.emit(row)"></tr>
  </table>
  @if (!locationAdminStore.usersOfRepairerSite()?.length) {
    <div>
      <div class="no-results">No users</div>
    </div>
  }
</div>
